<template>
    <div class="error-summary">
        <div>
            <img alt="error" src="/images/signup/alert_ring.svg" />
            <span>{{ errorMessage }} </span>
        </div>
    </div>
</template>

<script setup lang="ts">
interface Props {
  errorMessage?: string
}
const props = withDefaults(defineProps<Props>(), {
  errorMessage: "Almost there! Just a few more details to complete before we can move forward. ",
})
</script>

<style scoped>
.error-summary {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 12px !important;

    border-radius: 12px;
    border: 1px solid var(--text-red, #F92D2D);
    background: #FFF4F4;
    margin-bottom: 20px;

    div {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: row;
        gap: 12px;
    }
}
</style>